/**
 * External dependencies
 */
import React from "react";

/**
 * Internal dependencies
 */
import Configuration from "./base/configuration";
import ConfigureComparision from "./base/configure-comparison";
import ConfigureLimit from "./base/configure-limit";
import ConfigureSort from "./base/configure-sort";
import ConfigureRowTotals from "./base/configure-row-totals";
import ConfigureStacked from "./base/configure-stacked";
import ConfigureHideLegend from "./base/configure-hide-legend";
import ConfigureLabelAngle from "./base/configure-label-angle";

const BarChartConfiguration = (props) => {
  return (
    <Configuration title="Configure bar chart">
      <ConfigureLimit />
      <ConfigureSort />
      <ConfigureComparision />
      <ConfigureRowTotals />
      <ConfigureStacked />
      <ConfigureLabelAngle />
      <ConfigureHideLegend />
    </Configuration>
  );
};

export default BarChartConfiguration;
